import { Menu } from '@base-ui/react/menu'
import { twMerge } from 'tailwind-merge'
import { listItemVariants } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface MenuRadioItemProps extends PartProps<Menu.RadioItem.Props> {
  className?: string
}

/** The same row as Menu.Item. Its indicator trails the label, wherever it sits in the markup. */
function MenuRadioItem({ className, children, ...props }: MenuRadioItemProps) {
  return (
    <Menu.RadioItem data-slot="list-item" className={twMerge(listItemVariants(), className)} {...props}>
      {children}
    </Menu.RadioItem>
  )
}

export { MenuRadioItem }
